import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { setCarritoPromos } from "../../../Redux/actions/CarritoPromoAction";

// import CabezoteComponent from "../../Cabezote/cabezote.component";
// import Footer from "../../Footer/Footer.components";
import { CardProductoRedemption } from "./CardProductoRedemption.component";

export const Redemption = ({
  codigoSku,
  setShowModalRedemption,
  getProductos = () => {},
}) => {
  let carritoPromosRedux = useSelector(
    (state) => state.carritoPromo.carritoPromos
  );
  // let _carritoPromos = JSON.parse(localStorage.getItem('carritoPromos' ahora llamamos es al constant)) || {};
  // let history = useHistory();
  const dispatchPromo = useDispatch();
  //console.log("CodigoSKU", codigoSku ,"CAARRRIIITOOO",carritoPromosRedux)

  // const [open, setOpen] = useState(false);
  // const [close, setclose] = useState(true);
  // const [mensaje, setMensaje] = useState("");
  let producto = carritoPromosRedux["-" + codigoSku];
  const [productos, setProductos] = useState(producto.redime);

  const AgregarCarritoPromos = (carritoPromos) =>
    dispatchPromo(setCarritoPromos(carritoPromos));

  const limiteOriginal = producto.cantidadObsequiada;
  const [limite, setLimite] = useState(
    producto.cantidadObsequiada - producto.cantidadReclamada
  );
  const [numberSelected, setNumberSelected] = useState(producto.seleccionados);
  const [porcentaje, setPorcentaje] = useState(producto.cantidadReclamada);

  const sumarSelecciones = () => {
    let suma = 0;

    numberSelected.map((mb) => (suma += mb.cantidad));

    setPorcentaje(suma);
    carritoPromosRedux["-" + producto.codigoSku]["cantidadReclamada"] = suma;
    setLimite(producto.cantidadObsequiada - producto.cantidadReclamada);
    AgregarCarritoPromos(carritoPromosRedux);
    getProductos();
  };

  const seleccionarCantidadMinima = (currentProduct, initValue) => {
    const filterProduct = carritoPromosRedux["-" + producto.codigoSku][
      "seleccionados"
    ].filter((ps) => ps.codigoSkuPromocion == currentProduct.codigoSku);

    if (!filterProduct.length) {
      let aux = [
        ...carritoPromosRedux["-" + producto.codigoSku]["seleccionados"],
        {
          codigoSkuPromocion: currentProduct.codigoSku,
          nombre: currentProduct.nombre,
          cantidad: initValue,
          tipoIntegracion: producto.tipoIntegracion,
          codigoPromocion: "-" + producto.codigoSku,
          unidadesxCaja: currentProduct.unidadesxCaja,
        },
      ];

      carritoPromosRedux["-" + producto.codigoSku]["seleccionados"] = aux;
      setNumberSelected(aux);
      AgregarCarritoPromos(carritoPromosRedux);
      getProductos();
    }
  };
  useEffect(() => {
    sumarSelecciones();
  }, [numberSelected]);

  return (
    <>
      <div className="cardRedemption">
        <i
          className="fa fa-times-circle-o"
          aria-hidden="true"
          onClick={() => {
            setShowModalRedemption(false);
          }}
        ></i>
        <div className="redemption scrollSlider">
          <div className="redemption-headerGrid">
            <div className="redemption-headerGrid-titles">
              <h2>Producto(s) para redemir</h2>
              <p>Selecciona los productos para enviártelos como obsequios</p>
            </div>
            <div className="redemption-headerGrid-summary">
              <div className="redemption-headerGrid-summary-wrapper">
                <div className="redemption-headerGrid-summary-wrapper-left">
                  <div className="redemption-headerGrid-summary-wrapper-left-letters">
                    <p className="one">
                      Cant. otorgada <span>{limiteOriginal}</span>{" "}
                    </p>
                    <p className="two">
                      Cant. usada <span>{porcentaje}</span>{" "}
                    </p>
                    <p className="three">
                      Cant. restante <span>{limite}</span>
                    </p>
                  </div>
                  <div className="redemption-headerGrid-summary-wrapper-left-bar">
                    <div
                      className="redemption-headerGrid-summary-wrapper-left-bar-inside"
                      style={{
                        width: (porcentaje * 100) / limiteOriginal + "%",
                      }}
                    ></div>
                  </div>
                </div>
                <div
                  className="redemption-headerGrid-summary-wrapper-right"
                  onCli
                  ck={() => {
                    setShowModalRedemption(false);
                  }}
                >
                  <button>Finalizar</button>
                </div>
              </div>
            </div>
          </div>

          <div className="redemption-bodyGrid">
            {productos?.map((pro, i) => {
              let counter = producto.seleccionados.find(
                (se) => se.codigoSkuPromocion == pro.codigoSku
              );
              let initValue = producto.tipoIntegracion ? pro.cantidadMin : 0;

              if (initValue > 0) seleccionarCantidadMinima(pro, initValue);

              return (
                <CardProductoRedemption
                  key={pro.codigoSku + "" + i}
                  codigoSku={producto.codigoSku}
                  outsideCounter={counter ? counter.cantidad : initValue}
                  producto={pro}
                  tipoIntegracion={producto.tipoIntegracion}
                  limite={limite}
                  setLimite={setLimite}
                  numberSelected={numberSelected}
                  setNumberSelected={setNumberSelected}
                />
              );
            })}
          </div>

          <div className="redemption-footer">
            <button
              onClick={() => {
                setShowModalRedemption(false);
              }}
            >
              Volver
            </button>
          </div>
        </div>
      </div>
      <div
        className="background principal secundario"
        onClick={() => {
          setShowModalRedemption(false);
        }}
      ></div>
    </>
  );
};
